import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { Alert, Spin } from 'antd';
import { Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Switch } from 'react-router';
import { history } from '$src/stores/history';
import useStores from '$src/hooks/useStores';
import useFeature from '$src/hooks/useFeature';
import Honeypot from '$src/components/Honeypot';
import './index.less';
import LoadingFallback from '../LocationsSelector/LoadingFallback';

function PrivateRoute(props) {
  const { featureFlag, featureFlagLocationLevel, ...restProps } = props;
  const { sessionStore } = useStores();
  const { user, fetchMe, authorized, isLoading } = sessionStore;
  const [isFeatureEnabled] = useFeature(featureFlag, featureFlagLocationLevel);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  function renderRoute() {
    // eslint-disable-next-line react/prop-types
    const { component: Component } = props;

    return (
      <>
        <Honeypot />
        <Component {...props} user={toJS(user)} fetchCurrentUser={fetchMe} loading={isLoading} />
      </>
    );
  }

  if (isLoading) {
    return (
      <div className="private-route__spin-container">
        <LoadingFallback />
      </div>
    );
  }

  if (featureFlag && !isFeatureEnabled) history.push('/not-found');

  if (!authorized) {
    return <Alert message="Error" description="User not authorized. Refresh to try again." type="error" showIcon />;
  }
  const route = (
    <Switch>
      <Route user={toJS(user)} {...restProps} component={renderRoute} />
    </Switch>
  );
  return route;
}

PrivateRoute.propTypes = {
  featureFlag: PropTypes.string,
  featureFlagLocationLevel: PropTypes.bool,
};

PrivateRoute.defaultProps = {
  featureFlagLocationLevel: false,
};

export default observer(PrivateRoute);
